import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_login_template} from "../components/templates/config_login_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_login extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected configLogin: config_login_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage() {
        this.getGeneralConfigData()
    }

    buildContent(): Array<Element> {
        this.configLogin = new config_login_template("config_login", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Login Settings");

        return [this.configLogin.build()];
    }

    protected getModuleName(): string {
        return "config_login";
    }

    private getGeneralConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/login-settings/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let response = responseParsed.data;

                //set login system email templates
                obj.configLogin.setLoginSystemEmailTemplates(response.newsletterTemplates);
                obj.configLogin.setPersonalThreadNotificationEmailTemplates(response.allTemplates);
                obj.configLogin.setFollowUpdateNotificationEmailTemplates(response.allTemplates);

                if (response.loginSettings != null) {

                    obj.configLogin.setMaxUnauthenicatedArticleViews(response.loginSettings.maxUnauthenicatedArticleViews);
                    obj.configLogin.setLowRangeMinimumRate(response.loginSettings.lowRangeMinimumRate);
                    obj.configLogin.setLowRangeArticleTarget(response.loginSettings.lowRangeArticleTarget);
                    obj.configLogin.setMidRangeMinimumRate(response.loginSettings.midRangeMinimumRate);
                    obj.configLogin.setMidRangeArticleTarget(response.loginSettings.midRangeArticleTarget);
                    obj.configLogin.setHighRangeMinimumRate(response.loginSettings.highRangeMinimumRate);
                    obj.configLogin.setHighRangeArticleTarget(response.loginSettings.highRangeArticleTarget);
                    obj.configLogin.setSkipBannerEnable(response.loginSettings.skipBannerEnable ? true : false);
                    obj.configLogin.setSkipBannerEnableTopButton(response.loginSettings.skipBannerEnableTopButton ? true : false);
                    obj.configLogin.setNewsletterHeadline(response.loginSettings.newsletterHeadline);
                    obj.configLogin.setNewsletterDescription(response.loginSettings.newsletterDescription);
                    obj.configLogin.setPremiumOfferUrlForAdRemoval(response.loginSettings.premiumOfferUrlForAdRemoval);
                    obj.configLogin.setHasActionBar(response.loginSettings.hasActionBar);
                    obj.configLogin.setHasThreadSuggestions(response.loginSettings.hasThreadSuggestions);
                    obj.configLogin.setGoogleClientId(response.loginSettings.googleClientId);
                    obj.configLogin.setAmazonClientId(response.loginSettings.amazonClientId);
                    obj.configLogin.setOpenPassClientId(response.loginSettings.openPassClientId);
                    obj.configLogin.setFacebookClientId(response.loginSettings.facebookClientId);
                    obj.configLogin.setFacebookClientSecret(response.loginSettings.facebookClientSecret);
                    obj.configLogin.setDiscordClientId(response.loginSettings.discordClientId);
                    obj.configLogin.setDiscordClientSecret(response.loginSettings.discordClientSecret);
                    obj.configLogin.setAppleClientId(response.loginSettings.appleClientId);
                    obj.configLogin.setSortables(response.loginSettings.loginPlatformOrder);
                    if(response.loginSettings.loginSystemEmailTemplateId){
                        obj.configLogin.setLoginSystemEmailTemplate(response.loginSettings.loginSystemEmailTemplateId);
                    }
                    if(response.loginSettings.personalThreadNotificationEmailTemplateId){
                        obj.configLogin.setPersonalThreadNotificationEmailTemplate(response.loginSettings.personalThreadNotificationEmailTemplateId);
                    }

                    if(response.loginSettings.followUpdateNotificationEmailTemplateId){
                        obj.configLogin.setFollowUpdateNotificationEmailTemplate(response.loginSettings.followUpdateNotificationEmailTemplateId);
                    }
                }
            });
        }
    }

    public filterDropdownOnChange(data) {
        // dropdowns cry without this, we don't really need it
    }

    protected saveLoginSettings(param, data) {
        this.loadingIn(this.configLogin.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/login-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configLogin.getLoginSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/login/");

                });
                obj.loadingOut(obj.configLogin.builtTemplate);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");

            }
        });
        XHRHdl.execute();
    }


    protected cancelSiteSettings() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "LOGIN SETTINGS changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/login/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_login.ts